export default {
  INVESTMENT_GOALS_REPOSITORY: Symbol.for('INVESTMENT_GOALS_REPOSITORY'),
  GET_INVESTMENT_GOALS_QUERY: Symbol.for('GET_INVESTMENT_GOALS_QUERY'),
  INVESTMENT_GOALS_STATE_MANAGER: Symbol.for('INVESTMENT_GOALS_STATE_MANAGER'),
};
